import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, useTheme } from '../App';
import { Logo } from '../components/Logo';

export default function ResetPassword() {
  const [password,  setPassword]  = useState('');
  const [confirm,    setConfirm]  = useState('');
  const [error,      setError]    = useState('');
  const [success,    setSuccess]  = useState(false);
  const [loading,    setLoading]  = useState(false);
  const { theme } = useTheme();
  const navigate  = useNavigate();
  const isDark = theme === 'dark';

  const token = new URLSearchParams(window.location.search).get('token');

  async function handleSubmit(e) {
    e.preventDefault(); setError('');

    if (!token) return setError('Link ist ungültig. Bitte fordere einen neuen an.');
    if (password.length < 8) return setError('Passwort muss mindestens 8 Zeichen haben.');
    if (password !== confirm) return setError('Passwörter stimmen nicht überein.');

    setLoading(true);
    try {
      await api('/auth/reset-password', { method: 'POST', body: JSON.stringify({ token, new_password: password }) });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  }

  return (
    <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, position: 'relative' }}>
      <div style={{ position: 'fixed', top: '5%', left: '10%', width: 500, height: 500, borderRadius: '50%', pointerEvents: 'none', background: 'radial-gradient(circle, rgba(0,100,200,0.18) 0%, transparent 65%)', filter: 'blur(60px)' }} />

      <div className="fade-up" style={{ width: '100%', maxWidth: 420, position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: 32, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
          <Logo size="lg" />
          <p style={{ color: 'var(--text2)', fontSize: 13 }}>Neues Passwort festlegen.</p>
        </div>

        <div className="glass-intense" style={{ padding: 28, borderRadius: 20 }}>
          {success ? (
            <div style={{ textAlign: 'center', padding: '12px 0' }}>
              <p style={{ color: 'var(--green)', fontSize: 14, fontWeight: 600, marginBottom: 8 }}>Passwort geändert.</p>
              <p style={{ color: 'var(--text2)', fontSize: 12 }}>Du wirst zum Login weitergeleitet...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <label style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <span style={{ fontSize: 10, fontWeight: 600, fontFamily: 'Outfit', color: 'var(--muted)', letterSpacing: '0.08em' }}>NEUES PASSWORT</span>
                <input type="password" className="input" value={password} onChange={e => setPassword(e.target.value)} placeholder="Mindestens 8 Zeichen" required style={{ fontSize: 13 }} />
              </label>
              <label style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <span style={{ fontSize: 10, fontWeight: 600, fontFamily: 'Outfit', color: 'var(--muted)', letterSpacing: '0.08em' }}>PASSWORT BESTÄTIGEN</span>
                <input type="password" className="input" value={confirm} onChange={e => setConfirm(e.target.value)} placeholder="Wiederholen" required style={{ fontSize: 13 }} />
              </label>

              {error && (
                <div style={{ padding: '9px 13px', borderRadius: 8, fontSize: 12, background: 'rgba(255,0,85,0.08)', border: '1px solid rgba(255,0,85,0.2)', color: 'var(--red)' }}>{error}</div>
              )}

              <button type="submit" disabled={loading} className="btn-primary" style={{ marginTop: 4, padding: '12px', fontSize: 14, justifyContent: 'center', width: '100%' }}>
                {loading ? 'Speichere...' : '▶ Passwort speichern'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
